<div class="captor-cell">
  <div class="captor-cell__main">
    <p class="captor-cell__name">{{ agentName }}</p>
    <span
      *ngIf="hasCobrokers && !expanded"
      class="captor-cell__pill"
      [matTooltip]="tooltipText"
      matTooltipClass="cobrokers-tooltip"
      matTooltipPosition="below"
    >
      <qr-icon [name]="ICON_COBROKERS" color="grey-600"></qr-icon>
      {{ cobrokers.length }}
    </span>
  </div>
  <p class="captor-cell__subtext" *ngIf="referredName">
    Referido: {{ referredName }}
  </p>
  <p
    class="captor-cell__subtext captor-cell__subtext--wrap"
    *ngIf="expanded && hasCobrokers"
  >
    {{ cobrokersLabel }} {{ cobrokers.join(', ') }}
  </p>
</div>
